export default "__VITE_ASSET__B_vjF3ey__"